var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _g3, _g4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g5, _path28, _g6, _g7, _path29, _path30, _g8, _g9, _path31, _g10, _path32, _path33, _path34, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 837.491,
    height: 646.228,
    viewBox: "0 0 837.491 646.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -263.155,
    y1: 0.975,
    x2: -262.45,
    y2: 0.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -375.315,
    y1: 0.812,
    x2: -375.811,
    y2: 0.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1116.052,
    y1: 0.441,
    x2: -1117.235,
    y2: 0.585,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#babbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c9cbd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#d2d4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#c0c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -898.094,
    y1: 0.568,
    x2: -898.864,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -458.039,
    y1: 0.721,
    x2: -458.266,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -251.396,
    y1: 0.975,
    x2: -250.691,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -358.554,
    y1: 0.812,
    x2: -359.05,
    y2: 0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1066.141,
    y1: 0.441,
    x2: -1067.324,
    y2: 0.585,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -857.958,
    y1: 0.568,
    x2: -858.728,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -437.485,
    y1: 0.721,
    x2: -437.712,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.497,
    y1: 0.518,
    x2: 1.723,
    y2: 0.87,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.016,
    y1: 0.028,
    x2: 0.869,
    y2: 0.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "package-image",
    transform: "translate(1.849 -502.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(175.063 711.688)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M448.612,440.363,824.486,659.542s34.432,17.386,68.554,19.633,63.766-12.939,84.479-22.4,68.4-36.9,78.3-46.152,37.04-28.781,10.191-55.093-466.225-254.355-501.825-255.8S420.063,389.34,417.321,405.177C414.717,420.26,428.56,428.783,448.612,440.363Z",
    transform: "translate(-417.006 -242.086)",
    opacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M103.563,1738.057l85.359,48.777,293.769,166.285V1873.3L103.563,1666,82.5,1687.063Z",
    transform: "translate(-34.708 -1548.492)",
    fill: "#1e1e1e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(178.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M451.582,344.263l1.229,5.723,6.286,8.022L501.68,379.79l1.322.868,3.823,2.206V364.289c0-25.3,17.872-35.491,39.923-22.758s39.928,43.564,39.928,68.864v18.569L798.659,551.355l.863.429V533.277c0-25.3,17.877-35.486,39.922-22.764s31.591,36.824,31.591,62.123v12.345l.532.263s1.741.9,4.613,2.361c12.417,6.307,43.946,24.173,48.828,23.936,6.012-.294,8.559-15.542,8.559-15.542l-.144-1.328h-.005l-2.4-21.147-5.832-9.954-4.669-22.417,4.669-3.306-.671-11.431-.511-11.359-2.893-7.98L891.2,485.312s-34.545-29.649-70.428-61.653-66.126-48.507-81.519-57.81-37.531-22.924-65.31-32.268a173.03,173.03,0,0,0-63.461-9.091c-13.2.527-27.779,1-27.779,1s-29.235-6.5-54.013-17.981-38.946-15.568-50.692-17.96-19.633.32-19.633.32l-.072.992-5.2,32.882,1.364,6.973.754,12.738Z",
    transform: "translate(-451.582 -288.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M452.88,290.859l4.762,1.033,43.771,14.7s58.662,19.824,92.913,37.82,191.731,104.948,225.791,124.3,66.044,40.005,66.044,40.005l32.95,17.7-.511-11.359-2.893-7.98-29.917-21.767s-34.546-29.649-70.428-61.653-66.126-48.507-81.519-57.81-37.531-22.924-65.31-32.268a173.03,173.03,0,0,0-63.461-9.091c-13.2.527-27.779,1-27.779,1s-29.235-6.5-54.013-17.981-38.946-15.568-50.692-17.96-19.633.32-19.633.32Z",
    transform: "translate(-446.175 -288.559)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(146.364 48.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M657.945,488.648l-173.5-96.385-2.087-15.687v-8.921c-.17-1.467-2.9-25.475-2.371-40.15.542-14.948.547-21.844.547-21.911v-.419l5.909-7.3,1.818,1.467-5.387,6.663c-.01,1.7-.077,8.636-.547,21.586-.537,14.892,2.335,39.613,2.366,39.861l0,.134v8.91l1.917,14.292,170.8,94.876,35.346-41.457,8.347-17.438L699.516,415.3l2.319-.315,1.684,12.169-8.884,18.466Z",
    transform: "translate(-479.918 -297.878)",
    fill: "#01576d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M528.975,320.135l21.334,44.46-13.843-7.289-20.538-47.34Z",
    transform: "translate(-183.563 -199.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M497.576,303.9l5.919,8.434-15.849.469-17.395-6.492-4.282-5.084-11.751-4.172L453.8,289.2l21.093,4.636Z",
    transform: "translate(-442.334 -285.87)",
    fill: "#5e9395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M456.968,289.307l.779,10.729.593,16.182-6.467,4.409Z",
    transform: "translate(-450.37 -285.443)",
    fill: "#5e9395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M570.945,360.312l-3.1-.116-31.219-21.932,1.417-2.164-.729-4.918,22.174,2.1,6.26,6.371L570,344.3Z",
    transform: "translate(-97.336 -111.021)",
    fill: "#5e9395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M532.891,346s1.741.9,4.613,2.361c12.417,6.307,43.946,18.9,48.828,18.672,6.012-.289,8.559-10.279,8.559-10.279l-.145-1.328h-.005l-13.76-4.861-8.926,10.728Z",
    transform: "translate(-112.905 -49.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M587.239,364.927l-4.189-.328-48.934-24.63,7.834-1.332,26.916,12.091,11.269,6.34,1.276-.156V354.98Z",
    transform: "translate(-107.802 -79.968)",
    fill: "#289ab1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M676.437,415.294S485.026,319.209,481.2,316.688s-1.09-6.906,8.2-3.264c13.931,5.455,134.551,70.827,156.571,82.4C670.156,408.532,676.437,415.294,676.437,415.294Z",
    transform: "translate(-335.191 -190.777)",
    fill: "#289ab1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M453.3,294.436l25.685,11.536,10.52-2.078-24.318-10.437Z",
    transform: "translate(-444.421 -268.155)",
    fill: "#017695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M463.4,323.335c0,21.632,15.279,47.986,34.132,58.869s34.122,2.169,34.122-19.463-15.279-47.98-34.122-58.859S463.4,301.713,463.4,323.335Z",
    transform: "translate(-402.361 -244.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M520.066,356.056c0,21.627,6.942,41.235,25.785,52.123s34.127,2.17,34.127-19.463-6.942-41.235-25.785-52.118S520.066,334.429,520.066,356.056Z",
    transform: "translate(-166.326 -107.985)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(50.098 40.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M461.281,328.358v18.471l1.322.868,3.823,2.206V331.328c0-25.3,17.872-35.491,39.922-22.758s39.928,43.564,39.928,68.864V396l5.145,2.97V380.4c0-28.559-20.176-63.368-45.072-77.738S461.281,299.8,461.281,328.358Z",
    transform: "translate(-461.281 -296.472)",
    fill: "#289ab1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M517.946,361.069v18.58l4.288,2.474.862.429V364.044c0-25.3,17.877-35.486,39.923-22.764S594.61,378.1,594.61,403.4v12.345l.532.263s1.741.9,4.613,2.361V406.379c0-28.559-11.844-56.632-36.736-71S517.946,332.515,517.946,361.069Z",
    transform: "translate(-225.254 -160.2)",
    fill: "#289ab1"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M510.305,448.948c69.623-5.811,166.23-74.515,172.165-84.985l6.354-16.142L521.917,434.95Z",
    transform: "translate(-28.388 -41.709)",
    fill: "#efefef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M542.221,499.748l42.223-11.894L617.968,472.3,663.86,445.81l27.675-19.779,12.107-19.476L701.611,380.1l-6.2-2.719-4.671-24.348,4.671-3.3-.943-16.01L533.053,426.914,506.747,458Z",
    transform: "translate(-43.208 -100.441)",
    fill: "#d2d2d2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M721.189,379.153l-18.353,14.724L689.622,404,626.728,440.31l-33.652,16.939-33.3,15.1L522.95,445.48l-22.618-29.009,162.215-93.656,38.674,32.919,19.725,16.641Z",
    transform: "translate(-69.929 -145.873)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M486.542,404.275l38.647-15.8,39.328-20.016,55.437-32.005,8.285-7.476,20.517-18.351,71.233,62.967-5.307,24.833-18.117,14.018-63.78,36.823-24.313,10.477-50.7,7.506Z",
    transform: "translate(-127.369 -196.65)",
    fill: "#37464e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M573.51,320.816,564.518,326l-39.329,20.016-38.647,15.806,68.167,60.263c1.374.909,2.717,1.777,4,2.567l49.757-7.366,24.313-10.475,12.51-7.221C640.112,377.67,591.1,335.413,573.51,320.816Z",
    transform: "translate(-127.368 -154.197)",
    fill: "#1c2121",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M575.621,288.812,555.7,293.259l-34.644,12.107-50.77,29.308L437.02,361.782l-13.59,14.892s53.2,12.913,82.862,28.378,31.452,13.037,31.452,13.037,71.6-66.586,162.216-93.657c-29.132-8.264-70.9-25.341-70.9-25.341l-30.651-9.912Z",
    transform: "translate(-390.249 -287.504)",
    fill: "#d8d8d8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M485.768,298.322c13.683-7.562,17.629-8.089,21.994-6.167,1.353.594,2.882,1.234,3.326,2.732,1.064,3.575-.744,9.571-2.1,13.657-1.922,5.806-10.558,9.861-17.578,12.009-4.329,1.328-11.26-2.211-13.182-3.864s-1.467-2.887-1.043-6.72S481.165,300.869,485.768,298.322Z",
    transform: "translate(-167.88 -277.515)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M485.013,299.477c-3.7,2.567-4.675,3.383-5.294,5.723s-1.88,7.423-1.2,9.5,7.175,3.223,13.1,0,9.36-6.239,9.824-7.174a54.588,54.588,0,0,0,2.185-10.966c.258-3.693-.367-4.628-.94-4.778S495.876,292.612,485.013,299.477Z",
    transform: "translate(-161.609 -275.183)",
    fill: "#9099af"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M501.374,291.925c-3.223-.155-18.5,8.006-20.764,11.131-.759,1.054-3.611,12.851-.909,12.707s4.628.331,11.178-3.1,8.471-5.563,8.833-6.234a59.026,59.026,0,0,0,1.921-9.881A15.783,15.783,0,0,0,501.374,291.925Z",
    transform: "translate(-160.61 -274.547)",
    fill: "#cdcec2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M590.572,296.538c-36.684,4.4-47.727,7.237-59.4,11.338s-63.843,35.336-74.2,44.489-11.4,33.543-11.4,33.543Z",
    transform: "translate(-298.066 -255.323)",
    fill: "#383838"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M445.561,389.365l16.916-25.217,24.8-18.88,55.333-31.945,18.076-5.877,47.091-11.738,55.822.933-37.748,12.49L519.5,370.535,501.381,390.3Z",
    transform: "translate(-298.064 -258.78)",
    fill: "#37464e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M728.814,414.065s3.141,12.211,3.213,12.64-11.818,1.41-11.818,1.41L481.452,302.495l-2.546-4.184s31.581-3.466,56.72-.238,57.655,19.385,73.869,28.952,58.931,35.78,73.688,48.378S728.814,414.065,728.814,414.065Z",
    transform: "translate(-159.174 -254.658)",
    fill: "#566770"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M618.584,295.889s35.63,4.024,73.291,24.768c43.394,23.9,28.213,22.939,82.562,51.343l-6.095,6.591-20.775,18.12-55.44,32.015-53.275,26.038-26.627,10.888-26.363-19.189L515.6,406.122l-33.972-12.955-25.263-3.621,18.115-19.768,27.448-19.127,62.216-35.92,16.689-6.353Z",
    transform: "translate(-253.052 -258.026)",
    fill: "#efeef0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M520.445,446.215l38.672-16.989L599.533,411.2l45.58-25.524,20.141-15.889,16.6-16.772-6.5-11.521.673,3.506h0l-17.415,14.981L641.875,373.21l-58.284,33.433L551.8,421.251l-40.4,18.214Z",
    transform: "translate(-23.826 -68.059)",
    fill: "#d2d3d4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M501.56,327.244l-3.609,6.7,71.45,57.58,17.781,1.912-30.936,4.58-69.336-65Z",
    transform: "translate(-125.841 -127.422)",
    fill: "#efeef0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(26.392 75.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M422.116,362.909l1.224,5.728L428.1,380.1l32,25.491,1.322.868,3.827,2.206-2.918-17.81c0-25.294,17.872-35.491,39.923-22.758s39.928,43.564,39.928,68.859l2.913,17.815L757.081,577.16l.863.429-2.914-17.748c0-25.295,17.877-35.491,39.923-22.758s39.928,43.559,39.928,68.859l2.913,11.586.532.263s1.741.9,4.618,2.361c12.412,6.307,29.814,5.894,34.7,5.661,6.012-.289,17.247-6.6,17.247-6.6l-.144-1.328-.006-.005-2.4-21.147-7.768-8.833-2.732-23.538,4.669-3.306-.671-11.431-.511-11.359-6.767-5.739L846.7,511.871s-32.609-30.76-68.492-62.764S717.1,397.7,701.7,388.394s-37.531-22.918-65.31-32.263-57.2-5.6-70.408-5.083a87.8,87.8,0,0,1-22.768-1.891,414.462,414.462,0,0,0-43.993-23.771c-24.773-11.477-42.438-16.87-54.189-19.267s-16.131,1.622-16.131,1.622l-.072,1-6.715,37.082,1.364,6.973,2.257,9.308Z",
    transform: "translate(-422.114 -293.827)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M572.809,420.617c9.375,15.465,6.844-7.009-.888-29.411s-27.361-36.756-45.7-42.438-41.71-5.238-40.517,31.1c13.652-23.3,31.637-19.329,31.637-19.329l19.567,6.916,18.2,20.351Z",
    transform: "translate(-157.445 -124.174)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M514.8,390.042c5.873,19.039,5.558-9.84-2.169-32.242s-27.361-36.756-45.708-42.438-38.053.32-37.707,26.281c13.657-23.3,22.542-15.651,22.542-15.651l20.93,5.264,25.181,22.288Z",
    transform: "translate(-392.548 -260.351)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M640.654,439.454s-187.521-95.822-191.349-98.342.852-14.664,10.145-11.023S550.912,380.2,575.1,392.909,640.654,439.454,640.654,439.454Z",
    transform: "translate(-314.433 -193.642)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M423.416,308.74l4.763,1.038,43.771,14.7s43.626,28.5,77.877,46.5c34.246,17.986,191.731,104.943,225.791,124.293s66.038,40.01,66.038,40.01l38.766,14.339-.511-11.359-6.767-5.739L846.3,508.978s-32.608-30.765-68.5-62.769-66.121-48.507-81.519-57.815-37.531-22.918-65.31-32.263-57.2-5.6-70.408-5.083a87.8,87.8,0,0,1-22.769-1.891,414.465,414.465,0,0,0-43.993-23.771c-24.773-11.477-42.438-16.87-54.189-19.267s-16.131,1.622-16.131,1.622Z",
    transform: "translate(-416.7 -293.827)",
    fill: "#dee2e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(131.339 69.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M625.571,507.339l-173.5-96.374-2.087-15.692v-8.926c-.176-1.467-2.9-25.465-2.371-40.145.542-14.954.547-21.844.547-21.911v-.418l5.909-7.3,1.818,1.477-5.387,6.663c-.01,1.694-.077,8.631-.547,21.576-.537,14.892,2.335,39.613,2.36,39.861l.01.14v8.91l1.916,14.293,170.8,94.876,35.346-41.457,8.347-17.433L667.141,434l2.319-.325,1.684,12.174-8.884,18.461Z",
    transform: "translate(-447.543 -316.569)",
    fill: "#bfc3c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M696.439,435.537s3.141,12.211,3.213,12.639-11.818,1.41-11.818,1.41L449.077,323.972l-2.546-4.194s38.528-7.474,63.667-4.246,57.655,19.385,73.869,28.952,58.931,35.78,73.688,48.378S696.439,435.537,696.439,435.537Z",
    transform: "translate(-320.419 -254.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M447.611,319.455c8.631-1.431,27.035-4.122,43.729-4.122a111.751,111.751,0,0,1,13.957.78c22.929,2.944,53.476,17.216,72.67,28.549,14.246,8.409,58.28,35.289,73.239,48.058,13.305,11.353,34.6,37.676,37.846,41.72.7,2.7,1.591,6.178,2.221,8.673-2,.227-4.731.49-7.288.708Z",
    transform: "translate(-315.92 -252.29)",
    fill: "#37464e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M498.51,338.784l.464,35.637-13.844-7.284.33-38.518Z",
    transform: "translate(-159.641 -196.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M423.829,320.1s.868-6.271,2.629-8.2c1.079-1.183,5.119-6.6,7.681-8.424,1.612-1.136,2.34.842,2.34.842s-4.6,5.635-4.8,8.254.243,5.852,11.266,10.047c6.792,2.588,8.2,6.55,8.2,6.55l-1.839,3.946s-13.807.558-20.956-4.494C424.046,323.4,423.829,320.1,423.829,320.1Z",
    transform: "translate(-414.979 -303.128)",
    fill: "#cdcec2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M428.724,306.317l-.734,14.931.593,16.187-6.467,4.4Z",
    transform: "translate(-422.116 -289.842)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M502.694,366.992s1.741.9,4.618,2.361c12.412,6.307,29.814,5.894,34.7,5.661,6.012-.289,17.247-6.6,17.247-6.6l-.144-1.328-.005-.005-19.571-1.508h0a13.813,13.813,0,0,1-16.855,5.739Z",
    transform: "translate(-86.483 -43.029)",
    fill: "#f2eaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M553.952,374.831l-6.126.787-44.47-15.657,7.833-1.327,18.578,5.347,15.143,4.1,1.784.494Z",
    transform: "translate(-83.728 -71.929)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M423.544,316.559l22.187,10.23,9.052-7.309-22.851-5.2Z",
    transform: "translate(-416.167 -256.679)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M431.024,342.034c0,21.622,15.279,47.981,34.127,58.859s34.127,2.169,34.127-19.453S484,333.454,465.151,322.571,431.024,320.4,431.024,342.034Z",
    transform: "translate(-385.01 -241.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M487.69,374.742c0,21.632,15.279,47.986,34.127,58.864s34.127,2.175,34.127-19.458-15.279-47.98-34.127-58.859S487.69,353.121,487.69,374.742Z",
    transform: "translate(-148.979 -105.382)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(35.074 62.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M428.906,347.053l2.913,17.707,1.322.868,3.827,2.206-2.918-17.81c0-25.294,17.872-35.491,39.923-22.758S513.9,370.829,513.9,396.123l2.913,17.815,5.145,2.965-2.913-17.81c0-28.559-20.176-63.363-45.072-77.743S428.906,318.494,428.906,347.053Z",
    transform: "translate(-428.906 -315.163)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M485.571,379.766l2.918,17.81,4.282,2.479.862.429-2.913-17.748c0-25.295,17.877-35.491,39.923-22.758s39.928,43.559,39.928,68.859l2.913,11.586.532.263s1.741.9,4.618,2.361l-2.918-11.234c0-28.559-20.181-63.373-45.073-77.743S485.571,351.207,485.571,379.766Z",
    transform: "translate(-192.879 -178.888)",
    fill: "#9099af"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M515.37,324.007l13.879-8.76,3.5,1.24,61.922,61.271,2.025,13.574,6.493-17.738-73.936-62.97S513.618,319.307,515.37,324.007Z",
    transform: "translate(-7.864 -196.65)",
    fill: "#efeef0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M450.768,312.653l3.383,4.215s23.982-2.366,40.625-2.128l16.642.238-.713,6.152-57.66,3.079-8.6-5.289Z",
    transform: "translate(-302.69 -188.199)",
    fill: "#f2f2f2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M473.635,300.946c7.014-1.131,14.985-1.049,28.471-1.364s35.1-.635,36.364-.553-2.366,3.151-2.366,3.151l13.053-5.16a185.128,185.128,0,0,0-21.023-1.514c-11.828-.186-39.117.63-39.117.63Z",
    transform: "translate(-181.13 -259.731)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(365.109 320.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M555.94,414.149c0,21.632-15.279,30.341-34.127,19.463s-34.122-37.237-34.122-58.869,15.279-30.336,34.122-19.452S555.94,392.527,555.94,414.149Z",
    transform: "translate(-487.691 -350.603)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M555.94,414.149c0,21.632-15.279,30.341-34.127,19.458s-34.122-37.232-34.122-58.864,15.279-30.336,34.122-19.452S555.94,392.527,555.94,414.149Z",
    transform: "translate(-487.691 -350.603)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M553.437,412.124c0,20.811-14.7,29.189-32.826,18.719s-32.831-35.816-32.831-56.622,14.7-29.184,32.831-18.719S553.437,391.323,553.437,412.124Z",
    transform: "translate(-487.316 -348.97)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M544.684,404.311c0,17.717-12.515,24.855-27.954,15.935s-27.96-30.5-27.96-48.218,12.516-24.85,27.96-15.935S544.684,386.589,544.684,404.311Z",
    transform: "translate(-483.197 -343.73)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(7.624 9.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M542.158,401.763c0,16.792-11.864,23.548-26.5,15.109s-26.493-28.915-26.493-45.7,11.859-23.559,26.493-15.108S542.158,384.971,542.158,401.763Z",
    transform: "translate(-489.167 -352.421)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M489.736,374.5c1.111,9.644,5.94,20.641,13.564,29.4,7.619,8.734,16.24,13.135,23.156,12.7a11.93,11.93,0,0,0,7.913-3.492,10.8,10.8,0,0,0,1.886-2.361,5.709,5.709,0,0,0,.315-.522,12.872,12.872,0,0,0,1-2.061,20.2,20.2,0,0,0,.956-3.017,27.43,27.43,0,0,0,.635-6.059c0-.971-.047-1.973-.134-2.97-.026-.522-.093-1.018-.16-1.519l-.14-1.023c-.041-.315-.088-.63-.155-.95-.16-.95-.341-1.932-.594-2.9-.114-.475-.222-.93-.362-1.41a9.052,9.052,0,0,0-.341-1.178c-.155-.568-.336-1.157-.542-1.72-.14-.434-.274-.862-.429-1.271a53.654,53.654,0,0,0-2.319-5.47c-.181-.382-.361-.749-.542-1.111-.636-1.224-1.291-2.428-2.02-3.631-.181-.294-.361-.584-.542-.883-.341-.542-.7-1.09-1.043-1.606a57.869,57.869,0,0,0-4.468-5.878c-.816-.93-1.632-1.813-2.474-2.629-.382-.408-.79-.8-1.177-1.162-.114-.108-.248-.222-.362-.336-.315-.3-.661-.589-.976-.863a33.133,33.133,0,0,0-11.8-6.9c-6.71-2.02-12.722-.455-16.167,5.036-.114.16-.227.341-.321.5a17.594,17.594,0,0,0-1.565,3.631A28.7,28.7,0,0,0,489.736,374.5Z",
    transform: "translate(-487.835 -350.689)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M520.125,366.457l.253,7.438c2.789-.227,5.553-.5,8.141-.842-.341-.542-.7-1.09-1.044-1.606a57.885,57.885,0,0,0-4.468-5.878c-.816-.93-1.632-1.813-2.474-2.629-.382-.408-.79-.8-1.178-1.162-.114-.108-.248-.222-.362-.336-.315-.3-.661-.589-.976-.863a33.135,33.135,0,0,0-11.8-6.9c-6.71-2.02-12.722-.455-16.167,5.036C509.309,352.118,520.125,366.457,520.125,366.457Z",
    transform: "translate(-485.476 -350.689)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M489.842,357.41s6.42,8.507,13.016,10.754,19.375,17.691,19.375,17.691l-.976-28.941C506.175,358.045,489.842,357.41,489.842,357.41Z",
    transform: "translate(-486.355 -333.708)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M492.568,368.719c.95,8.28,5.1,17.738,11.658,25.248a35.486,35.486,0,0,0,11.25,8.931v.026a17.793,17.793,0,0,0,8.621,1.953,2.729,2.729,0,0,0,.609-.072,8.026,8.026,0,0,0,1.839-.336,27.446,27.446,0,0,0,.635-6.059c0-.971-.047-1.973-.134-2.97-.026-.522-.093-1.018-.16-1.519l-.14-1.023c-.042-.315-.088-.63-.155-.95-.16-.95-.341-1.932-.594-2.9-.113-.475-.222-.93-.361-1.41a9.071,9.071,0,0,0-.341-1.178c-.155-.568-.336-1.157-.542-1.72-.14-.434-.274-.862-.429-1.271a53.7,53.7,0,0,0-2.319-5.47c-.181-.382-.362-.749-.542-1.111-.636-1.224-1.291-2.428-2.02-3.631-.5-.837-1.043-1.674-1.586-2.49a57.88,57.88,0,0,0-4.468-5.878c-.816-.93-1.632-1.813-2.474-2.629-.382-.408-.79-.8-1.178-1.162-.114-.108-.248-.222-.362-.336-.315-.3-.661-.589-.976-.863a33.135,33.135,0,0,0-11.8-6.9,12.147,12.147,0,0,0-2.015,2.608,15.06,15.06,0,0,0-1.338,3.11,22.288,22.288,0,0,0-.863,5.263A30.786,30.786,0,0,0,492.568,368.719Z",
    transform: "translate(-475.859 -350.007)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M499.245,376.357l-.62,5.816v.021l.62-5.837,4.53-2.619L507.06,367c-.5-.837-1.043-1.674-1.586-2.49a57.882,57.882,0,0,0-4.468-5.878c-.816-.93-1.632-1.813-2.474-2.629-.382-.408-.79-.8-1.178-1.162-.114-.108-.248-.222-.362-.336-.888.522-1.612.971-1.658,1.018l5.672,6.519Z",
    transform: "translate(-463.475 -343.751)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M496.592,360.846l-.62,5.816v.021l4.468,14.447,2,6.513c.677,1.426-1.343,4.669-.413,4.489,1.5-.294,5.217-2.49,7.216-3.832a5.7,5.7,0,0,0,.315-.522,12.872,12.872,0,0,0,1-2.061,3.087,3.087,0,0,0-.341-1.044l-.542-1.637L501.5,359l-.382-.77Z",
    transform: "translate(-460.822 -328.239)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M494.614,354.653a1.514,1.514,0,0,1,1.451.16l21.679,9.179.609.351.021,11.638-4.814-2.768L495.6,366.166a4.681,4.681,0,0,1-2.1-3.5c-.124-2.546-4.039-3.1-3.559-5.3C490.027,356.946,494.325,354.8,494.614,354.653Z",
    transform: "translate(-486.143 -343.632)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(2.774 11.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M502.541,384.962l9.417-19.359c.465-.806.181-2.278-.682-3.445q-1.34-1.821-2.831-3.533c-1-1.142-2.014-2.206-3.037-3.192-.987-.95-2.061-1.038-2.526-.238l-9.416,19.36Z",
    transform: "translate(-474.034 -354.651)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M514.627,376.492l-.021-11.638L514,364.5l-21.679-9.179c-.981-.563-1.834-.279-2.045.7a27.594,27.594,0,0,0-.532,7.149,4.679,4.679,0,0,0,2.108,3.507l17.965,7.04Z",
    transform: "translate(-489.704 -353.04)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M511.626,388.145c.63-.5.656-1.73.062-2.965l-8.714-25.672-.372-.775-8.073,2.361,2.908,6.08,6.477,20.981c.672,1.415,1.932,2.371,2.862,2.185A11.329,11.329,0,0,0,511.626,388.145Z",
    transform: "translate(-469.606 -337.643)",
    fill: "#dfdfe3"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(72.406 151.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M499.278,381.437c0,21.627-15.279,30.336-34.127,19.453s-34.127-37.237-34.127-58.859,15.279-30.336,34.127-19.458S499.278,359.8,499.278,381.437Z",
    transform: "translate(-431.024 -317.887)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M499.278,381.437c0,21.622-15.279,30.336-34.127,19.453s-34.127-37.237-34.127-58.859,15.279-30.336,34.127-19.458S499.278,359.8,499.278,381.437Z",
    transform: "translate(-431.024 -317.887)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M496.771,379.411c0,20.806-14.7,29.189-32.825,18.714s-32.831-35.816-32.831-56.617,14.7-29.189,32.831-18.724S496.771,358.61,496.771,379.411Z",
    transform: "translate(-430.645 -316.259)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M488.018,371.592c0,17.717-12.521,24.855-27.955,15.94s-27.96-30.5-27.96-48.218,12.516-24.85,27.96-15.94S488.018,353.88,488.018,371.592Z",
    transform: "translate(-426.525 -311.017)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(7.629 9.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M485.492,369.043c0,16.792-11.865,23.554-26.5,15.109s-26.493-28.91-26.493-45.7,11.86-23.554,26.493-15.1S485.492,352.256,485.492,369.043Z",
    transform: "translate(-432.501 -319.705)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M433.07,341.787c1.111,9.644,5.94,20.641,13.559,29.4,7.624,8.729,16.245,13.13,23.156,12.7a11.967,11.967,0,0,0,7.919-3.492,11.076,11.076,0,0,0,1.885-2.36c.109-.181.227-.341.315-.522a12.722,12.722,0,0,0,1-2.066,19.79,19.79,0,0,0,.956-3.017,27.377,27.377,0,0,0,.63-6.054c0-.976-.041-1.973-.134-2.97-.021-.522-.093-1.023-.155-1.524l-.14-1.018c-.041-.32-.088-.635-.155-.956-.16-.95-.341-1.927-.594-2.9-.114-.48-.227-.935-.362-1.41a8.825,8.825,0,0,0-.341-1.178c-.16-.568-.341-1.157-.542-1.725-.14-.429-.274-.863-.429-1.266a53.731,53.731,0,0,0-2.319-5.47c-.181-.387-.362-.749-.542-1.116-.635-1.219-1.292-2.422-2.02-3.626-.181-.289-.362-.589-.542-.883-.341-.542-.7-1.09-1.044-1.612a58.432,58.432,0,0,0-4.468-5.873c-.816-.93-1.632-1.818-2.474-2.634-.382-.408-.79-.79-1.178-1.152-.114-.119-.248-.227-.362-.341-.32-.294-.661-.589-.976-.863a33.136,33.136,0,0,0-11.8-6.9c-6.71-2.015-12.722-.455-16.168,5.036a5.127,5.127,0,0,0-.32.5,17.3,17.3,0,0,0-1.565,3.626A28.7,28.7,0,0,0,433.07,341.787Z",
    transform: "translate(-431.169 -317.97)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M463.46,333.734l.253,7.438c2.789-.227,5.553-.5,8.141-.837-.341-.542-.7-1.09-1.044-1.612a58.432,58.432,0,0,0-4.468-5.873c-.816-.93-1.632-1.818-2.474-2.634-.382-.408-.79-.79-1.178-1.152-.114-.119-.248-.227-.362-.341-.32-.294-.661-.589-.976-.863a33.136,33.136,0,0,0-11.8-6.9c-6.71-2.015-12.722-.455-16.168,5.036C452.643,319.4,463.46,333.734,463.46,333.734Z",
    transform: "translate(-428.811 -317.97)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M433.176,324.7s6.42,8.507,13.017,10.749,19.37,17.7,19.37,17.7l-.971-28.946C449.5,325.333,433.176,324.7,433.176,324.7Z",
    transform: "translate(-429.69 -300.995)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M435.9,336c.951,8.28,5.1,17.738,11.658,25.243a35.38,35.38,0,0,0,11.25,8.936v.021a17.667,17.667,0,0,0,8.621,1.952,3.048,3.048,0,0,0,.61-.062,8.322,8.322,0,0,0,1.839-.346,27.377,27.377,0,0,0,.63-6.054c0-.976-.041-1.973-.134-2.97-.021-.522-.093-1.023-.155-1.524l-.14-1.018c-.041-.32-.088-.635-.155-.956-.16-.95-.341-1.927-.594-2.9-.114-.48-.227-.935-.362-1.41a8.815,8.815,0,0,0-.341-1.178c-.16-.568-.341-1.157-.542-1.725-.139-.429-.274-.863-.429-1.266a53.7,53.7,0,0,0-2.319-5.47c-.181-.387-.362-.749-.542-1.116-.635-1.219-1.292-2.423-2.02-3.626-.5-.837-1.043-1.679-1.586-2.495a58.446,58.446,0,0,0-4.468-5.873c-.816-.93-1.632-1.818-2.474-2.634-.382-.408-.79-.79-1.178-1.152-.114-.119-.248-.227-.362-.341-.32-.294-.661-.589-.976-.863a33.136,33.136,0,0,0-11.8-6.9,11.849,11.849,0,0,0-2.014,2.608A14.407,14.407,0,0,0,436.584,326a21.979,21.979,0,0,0-.863,5.258A30.868,30.868,0,0,0,435.9,336Z",
    transform: "translate(-419.193 -317.29)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M442.579,343.647l-.62,5.811v.026l.62-5.837,4.53-2.624,3.285-6.741c-.5-.837-1.043-1.679-1.586-2.495a58.454,58.454,0,0,0-4.468-5.873c-.816-.93-1.632-1.818-2.474-2.634-.382-.408-.79-.79-1.178-1.152-.114-.119-.248-.227-.362-.341-.888.522-1.611.976-1.658,1.018l5.666,6.519Z",
    transform: "translate(-406.809 -311.034)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M439.926,328.135l-.62,5.811v.026l4.468,14.442,2,6.508c.677,1.436-1.343,4.675-.413,4.494,1.5-.294,5.217-2.495,7.216-3.833.109-.181.227-.341.315-.522a12.717,12.717,0,0,0,1-2.066,3.116,3.116,0,0,0-.341-1.043L453,350.325l-8.166-24.05-.382-.764Z",
    transform: "translate(-404.156 -295.522)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M437.943,321.936a1.513,1.513,0,0,1,1.457.165l21.679,9.179.609.346.021,11.643-4.814-2.768-17.965-7.051a4.648,4.648,0,0,1-2.1-3.5c-.124-2.541-4.039-3.1-3.559-5.3C433.361,324.234,437.658,322.085,437.943,321.936Z",
    transform: "translate(-429.477 -310.919)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(2.771 11.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M445.876,352.241l9.416-19.354c.465-.806.175-2.278-.682-3.445q-1.34-1.829-2.836-3.538c-.992-1.136-2.009-2.206-3.032-3.187-.986-.95-2.066-1.038-2.526-.238l-9.416,19.36Z",
    transform: "translate(-417.366 -321.935)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M457.962,343.776l-.026-11.638-.6-.351-21.679-9.179c-.981-.563-1.834-.279-2.045.7a27.34,27.34,0,0,0-.532,7.149,4.687,4.687,0,0,0,2.1,3.5l17.97,7.051Z",
    transform: "translate(-433.038 -320.324)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M454.96,355.42c.63-.491.651-1.73.062-2.965l-8.714-25.666-.372-.77-8.073,2.355,2.908,6.08,6.477,20.976c.672,1.415,1.932,2.371,2.857,2.19A11.363,11.363,0,0,0,454.96,355.42Z",
    transform: "translate(-412.938 -304.923)",
    fill: "#dfdfe3"
  }))))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M505.2,435.652c7.779,7.955,26.431,12.552,41.069,12.872s26.632-.868,49.546-10.671c25.816-11.059,63.348-33.471,77.95-43.187s31.421-23.755,33.921-33.393c2.495-9.618-8.466-21.756-8.466-21.756s2.046,8.192,1.963,10.232c-.052,1.3,2.7,2.572,2.557,4.54-.352,4.778-4.742,11.627-13.146,18.2-18.228,14.246-53.869,35.749-97.728,57.02-20.666,10.021-47.6,12.3-61.3,10.026S505.2,435.652,505.2,435.652Z",
    transform: "translate(-49.652 -76.31)",
    fill: "#f2f2f2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M547.186,345.131a17.413,17.413,0,0,0,3.879-9.411,37.858,37.858,0,0,0-.775-4.737,12.549,12.549,0,0,1,1.353,4.737c.16,2.577,2.794,7.583-11.116,18.7A60.8,60.8,0,0,1,547.186,345.131Z",
    transform: "translate(97.5 -111.849)",
    fill: "#3f3f3f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M546.8,357.018c-7.748,1.9-9.644,2-16.9,0s-23.636-7.263-23.636-7.263,20.165,4.163,26.054,5.372,11.6.351,15.388-1.839S546.8,357.018,546.8,357.018Z",
    transform: "translate(-45.199 -33.658)",
    fill: "#383838"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M487.572,320.275,468.479,356.72l9.206,5.831,17.542-38.442Z",
    transform: "translate(-202.604 -156.449)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "package-bg",
    transform: "translate(-1.849 502.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 0)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M352.183,104.289c3.576-.956,8.561-2.92,14.356-2.595,1.829.1-5.164-5.176-7.988-4.781S352.183,104.289,352.183,104.289Z",
    transform: "translate(-201.729 90.044)",
    fill: "#e5c0ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(105.796 384.307)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M346.609,154.207c-3.13,13.859,1.249,55.093,4.309,68.11-2.346,2.639-3.06,9.55-1.5,17.1,1.575,7.695,14.554.217,23.256.5,28.1.912,37.007-5.795,36.21-10.6s-14.433-8.848-22.727-10.034-.931-63.884-1.007-66.638S346.609,154.207,346.609,154.207Z",
    transform: "translate(-343.28 0.475)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M363.928,127.852c-4.526,9.142-10,22.446-8.281,36.879a80.508,80.508,0,0,1,2.072,8.045c2.219,10.8-18.143,99.552-11.022,109.714s21.2,4.514,24.563.995,36.809-138.726,36.809-138.726Z",
    transform: "translate(-345.178 -127.852)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0.014 30.734)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M346.7,257.355c5.081,7.242,13.662,6.451,19.412,4.131l20.9-128.813s-14.86,13.6-29.121,22.115C357.853,172.427,339.958,247.722,346.7,257.355Z",
    transform: "translate(-345.18 -132.673)",
    fill: "url(#linear-gradient-11)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(114.253 539.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M383.936,228.6c-3.035-.6-4.813-3.149-5.846-5.827,2.186-14.892,9.722-50.911,12.476-66.759-27.208,1.728-41.673-3.787-41.673-3.787-4.137,23.422-2.066,55.794,0,68.193.2,1.237.383,2.32.561,3.315-1.211,8.224-4.469,24.863,1.1,26.584,6.662,2.014,16.014-.848,18.915-1.575,2.155-.523,25.251,1.332,32.806-2.843l1.81-1.288C411.571,231.437,390.687,229.55,383.936,228.6Z",
    transform: "translate(-346.504 -152.228)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(23.565 3.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M363.894,225.382c-3.041-.6-4.813-3.149-5.846-5.833,2.187-14.873,9.722-50.9,12.476-66.746-3.016.191-5.84.281-8.543.306-3.054,17.716-10.818,73.931-11.781,76.493,1.033,4.086,14.771,6.286,20.279,6.286a102.111,102.111,0,0,0,15-.956C383.931,227.537,369.326,226.154,363.894,225.382Z",
    transform: "translate(-350.201 -152.803)",
    fill: "#353535"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M428.727,134.043c-4.131,22.733-6.2,33.756-9.646,50.286-1.227,5.9-2.06,13.605-3.215,22.625-1.243,9.711-6.214,31.158-6.214,31.158s-3.1,8.44-5.373,12.352c-7.408,12.744-5.731,50.114-11.717,45.454-12.393-9.639-36.5-3.442-41.323-3.442s-9.3-2.754.344-27.546c12.157-31.269,18.59-72.331,16.524-89.556s-1.371-31,8.268-42.7S428.727,134.043,428.727,134.043Z",
    transform: "translate(-235.63 256.18)",
    fill: "#efeef0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(150.48 386.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M370.7,248.093c11.016-18.94,11.36-49.591,14.809-66.128s5.508-27.546,9.639-50.28c0,0-5.852-1.791-13.719-3.462l-.057.019c1.377,19.284-5.164,61.047-11.367,78.954s-9.99,30.568-12.055,38.142-1.377,22.045-2.754,28.93c-.759,3.774-1.721,10.436-3.009,15.8a22.756,22.756,0,0,1,6.8,3.487C364.962,298.213,363.286,260.843,370.7,248.093Z",
    transform: "translate(-352.187 -128.224)",
    fill: "#cbcbcb"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(146.336 231.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M365.211,106.895c.644,4.641-2.824,13.56-3.952,20.649-1.377,8.632-9.722,23.415-9.722,23.415l28.088,9.69s4.6-22.077,10.729-26.348C390.845,133.957,365.211,106.895,365.211,106.895Z",
    transform: "translate(-351.537 -87.626)",
    fill: "#e5c0ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M392.339,121.337c-1.147,16.951-8.23,32.506-15.007,33.137-6.8.644-22.4-12.68-23.664-25.812-1.294-13.113,6.681-25.474,19.584-24.76C387.347,104.667,393.238,108.192,392.339,121.337Z",
    transform: "translate(-340.816 -103.872)",
    fill: "#e5c0ae"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M408.8,119.9c-2.926-6.228-16-21.975-33.424-16.256-14.58,4.807-18.284,10.838-18.806,17.888-1.186,6.655-.459,15.217-1.345,17.735.995,5.546-3.353,11.022-4.131,9.639,3.423,6.4,6.719,0,6.719,0l-5.859,3.965a6.144,6.144,0,0,0,4.673,1.173c2.62-.51-2.773,2.62-2.773,2.62s11.9,4.131,13.56,4.335a81.585,81.585,0,0,0,8.306-.261s8.97.606,7.695-1.422c-2.627-4.2-.077-5.113,1.415-3.9,2.161,1.74,5.706-3.289,5.706-3.289s3.615-2.882.351-5.693c-1.721-1.3.236-6.3.37-7.331.529-4.278,5.272-5.98,5.145-1.74s2.085,3.36,2.085,3.36l1.989.217s3.1-9.154,4.9-12.374c3.086.612,7.631-1.1,8.364-5.291C413.548,124.224,411.3,122.349,408.8,119.9Z",
    transform: "translate(-207.593 119.738)",
    fill: "#070d41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M365.863,285.2a32.621,32.621,0,0,1-1.524-9.83h0c.383-26.641,31.614-47.494,57.879-54.436h0a149.122,149.122,0,0,0,3.946-34.119h0c2.1-22.691-96.069-105.581-109.176-131.33l-3.308-4.735,3.308-1.683c13.375,26.271,117.745,117.09,112.906,137.748v6.871c-.07,11.736-1.422,15.983-3.7,26.3h0a64.322,64.322,0,0,1,12.8-1.53h0a30.921,30.921,0,0,1,9.817,1.409h0l-1.179,3.525a27.6,27.6,0,0,0-8.638-1.224h0a60.006,60.006,0,0,0-13.732,1.8h0c-10.219,41.093-34.948,68.4-49.929,68.894h-.2c-4.284,0-7.924-2.869-9.263-7.663Zm27.884-47.36c-14.662,9.735-25.736,23.135-25.678,37.53h0a29.7,29.7,0,0,0,1.339,8.74h0c1.281,3.78,3.054,4.934,5.922,5.03h0c6.962.223,20.285-10.283,31.065-28.579h0a139.034,139.034,0,0,0,14.8-35.509h0a101.863,101.863,0,0,0-27.444,12.788Z",
    transform: "translate(-313.68 -49.069)",
    fill: "#282626"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(149.698 178.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M352.064,99.357l144.757,65.294,1.662-3.8L353.72,95.553Z",
    transform: "translate(-352.064 -95.553)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M66.705,37.334,172.85,126.657l41.571-75.382L70.031,29.851Z",
    transform: "translate(81.189 34.892)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(141.972 63.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M378.345,114.144c-.338.771-.924.287-1.9-.134l-.3-.127a1.761,1.761,0,0,1-1.179-2.142l2.257-5.349a1.76,1.76,0,0,1,2.365-.657l.287.127c.975.414,1.135,2.046.8,2.818Z",
    transform: "translate(-371.438 -105.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M380.6,106.191c-.95-.414-3.442-.994-4.692-.491-1.179,2.786-1.575,3.717-1.575,3.717s-.242,1.453,4.227,3.513C378.857,113.063,380.6,106.191,380.6,106.191Z",
    transform: "translate(-374.335 -105.504)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0.927 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M375.3,105.635a8.462,8.462,0,0,1,4.418.5,1.974,1.974,0,0,1,1.983-.166l.287.127c.975.414,1.785.229,1.46.994l-1.345,3.4-7.624-3.156Z",
    transform: "translate(-374.48 -105.507)",
    fill: "#353535"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(240.406 217.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M381.816,107.919c.14-2.269-.459-3.787-1.351-4.52-.778-.618-2.843.905-2.78,3.94.185-.848.089-1.607.325-2.843.918-4.915-3.876.064-3.876.064a27.332,27.332,0,0,0-.128,4.131c0-1.938-.319-1.938-.191-3.36.382-.969,1.154-1.039,1.224-2.129.108-1.881-2.129-1.849-2.971-.771-.414.535-2.257,3.289-2.257,3.289-.344,1.351-1.141,5.278-.905,7.044.313,2.187,2.263,12.68,2.263,12.68s-2.85,17.474-4.73,21.975c-1.913,4.577,15.574,8.938,15.574,8.938s1.849-22,3.959-27.642,1.275-16.148,1.275-16.148-1.428-6.33-3.812-6.649C382.517,105.789,382.064,106.446,381.816,107.919Z",
    transform: "translate(-366.293 -101.689)",
    fill: "#e5c0ae"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M366.231,147.649c16.39-2.072,26.227-6.222,37.472-11.4l13.521-29.911,6.585,3.36,7.357,8.007s-11.832,40.124-18.188,45.02-33.086,20.425-43.293,21.726C359.454,185.753,352.1,149.441,366.231,147.649Z",
    transform: "translate(-168.328 140.791)",
    fill: "#cbcbcb"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(114.83 264.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M436.138,132.712c-11.794-5.89-18.251-4.73-18.251-4.73s-12.183,2.422-16.269,2.327c-19.2,2.034-18.086-5.859-18.086-5.859s-14.777-16.314-19.112-15.325c-5.98,1.332-5.393,28.9-7.752,62.857-.255,3.749-16.046,49.209-7.58,66.128,4.96,9.894,56.2,3.226,72.331,11.711,5.043,2.646,11.252-19.775,11.7-24.454.484-4.673,0-23.766,8.192-60.945C441.315,164.421,438.663,133.968,436.138,132.712Z",
    transform: "translate(-346.595 -109.081)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M354.485,110.892l-2.461,3.742s2.856,6.789,10.328,7.229c8.791.516,25.321-1.026,29.2-3.353-3.621-4.654-2.588-6.2-2.588-6.2s-14.713,4-26.609,2.716A13.738,13.738,0,0,1,354.485,110.892Z",
    transform: "translate(-317.414 -99.348)",
    fill: "#050b41"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M422.333,105.874s-8.951,31-11.711,32.028S384.1,147.547,381,146.865s-16.365-.873-16.62-1.645-7.835,2.671-7.835,2.671,18.934,4.482,22.383,7.574,35.827-9.3,41.68-17.219,12.4-26.52,12.4-26.52S423.359,106.218,422.333,105.874Z",
    transform: "translate(-178.262 138.324)",
    fill: "#efeef0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M396.947,117.03c-1.071,2.518-4.692,3.392-8.115,1.951L353.616,104.1c-3.417-1.441-5.33-4.654-4.258-7.172h0c1.058-2.525,4.7-3.391,8.122-1.951l35.209,14.892c3.411,1.434,5.317,4.654,4.259,7.165Z",
    transform: "translate(-218.513 75.989)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M367.969,151.916l16.683-32.379s12.82-9.154,13.706-13.853c.019-.07,2.378-6.088.65-7.229-2.92-1.912-4.335,1.543-4.87,2.569a.68.68,0,0,0-.1-.1c.937-2.276,2.48-3.946,1.167-4.941-2.085-1.581-3.328.14-4.208,1.606.28-1.192,2.225-2.18-.319-3.092-1.409-.5-3.264,1.377-4.208,3.034-.057-.013-.076-.025-.108-.013.491-1.307,1.243-2.206-.453-3.034-1.256-.612-4.533,1.039-6.018,3.015-2.423,2.206-4.067,7.28-6.286,13.273-1.887,5.068-26.144,27.648-27.68,34.246C343.649,154.97,367.969,151.916,367.969,151.916Z",
    transform: "translate(-236.175 76.44)",
    fill: "#e5c0ae"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(104.709 203.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M384.836,173.324c-1.377-2.065-13.432-34.272-12.061-42.534s7.93-16.192,7.93-16.192-17.563-8.95-20.324-15.153c-8.268,13.776-16.02,21.018-15.332,32.034s10.334,69.226,22.739,79.043C374.808,216.081,384.836,173.324,384.836,173.324Z",
    transform: "translate(-345.007 -99.444)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(19.983 11.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M355.933,121.486c1.377-8.268,7.924-16.192,7.924-16.192s-3.334-1.7-7.318-4.118a172.418,172.418,0,0,0-7.835,18.507,20.465,20.465,0,0,0,.51,11.36c2.072,6.2,3.876,27.3,15.242,31.779,1.154.446,2.85-2.1,3.876-2.072C362.3,152.825,354.619,129.372,355.933,121.486Z",
    transform: "translate(-348.142 -101.175)",
    fill: "#efeef0"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(244.649 298.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M186.743,348.476a1.153,1.153,0,0,1-.948-.949l-.971-5.9-.972,5.9a1.153,1.153,0,0,1-.949.949l-5.894.971,5.894.971a1.152,1.152,0,0,1,.949.949l.972,5.894.971-5.894a1.152,1.152,0,0,1,.948-.949l5.9-.971Z",
    transform: "translate(-113.773 -228.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M144.046,312.629a.916.916,0,0,1-.757-.753l-.771-4.687-.774,4.687a.914.914,0,0,1-.757.753l-4.685.775,4.685.772a.915.915,0,0,1,.757.753l.774,4.688.771-4.688a.917.917,0,0,1,.757-.753l4.688-.772Z",
    transform: "translate(-136.303 -247.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M197.291,289.318a1.115,1.115,0,0,1-.921-.921l-.944-5.728-.945,5.728a1.119,1.119,0,0,1-.921.921l-5.729.946,5.729.941a1.122,1.122,0,0,1,.921.924l.945,5.728.944-5.728a1.118,1.118,0,0,1,.921-.924l5.729-.941Z",
    transform: "translate(-107.784 -261.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M512.932,344.757a7.519,7.519,0,0,0,9.555,6.352,8.358,8.358,0,0,0,7.806-.564,6.955,6.955,0,0,0,10.27-1.919,7.533,7.533,0,0,0,9.625-1.448,7.245,7.245,0,1,0,.253-11.216,6.6,6.6,0,0,0-10.129-1.108,5.989,5.989,0,0,0-5.748-4.359,5.917,5.917,0,0,0-1.26.138,6.494,6.494,0,0,0-12.74-1.625,7.419,7.419,0,0,0-12.293,5.627c0,.149.037.291.045.438-.085,0-.165-.023-.252-.023-3.658,0-6.626,2.6-6.626,5.8s2.967,5.8,6.626,5.8a7.043,7.043,0,0,0,4.865-1.887",
    transform: "translate(-131.537 -238.167)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M501.651,339.144a6.721,6.721,0,0,0,5.99,3.36,7.043,7.043,0,0,0,4.865-1.887,7.52,7.52,0,0,0,9.557,6.352,8.347,8.347,0,0,0,7.8-.565,6.955,6.955,0,0,0,10.271-1.917,7.533,7.533,0,0,0,9.627-1.449,7.192,7.192,0,0,0,11.726-3.93,7.18,7.18,0,0,0-11.165-3.144,6.6,6.6,0,0,0-10.129-1.108,5.989,5.989,0,0,0-5.748-4.359,5.917,5.917,0,0,0-1.26.138,6.494,6.494,0,0,0-12.74-1.625,7.419,7.419,0,0,0-12.293,5.627c0,.149.037.291.045.438-.085,0-.165-.023-.252-.023A6.55,6.55,0,0,0,501.651,339.144Z",
    transform: "translate(-131.311 -238.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M568.425,363.367c.009-.177.026-.353.026-.534a9.3,9.3,0,0,0-12.69-8.676,14.066,14.066,0,0,0-27.433,3.579,13.145,13.145,0,0,0-13.481,22.527,13.651,13.651,0,0,0,25.775,6.034,11.577,11.577,0,0,0,16.388-3.551,12.2,12.2,0,1,0,11.415-19.378",
    transform: "translate(-134.073 -227.029)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M575.643,367.676a12.2,12.2,0,0,0-7.762-4.309c.009-.177.026-.353.026-.534a9.3,9.3,0,0,0-12.69-8.676,14.066,14.066,0,0,0-27.433,3.579,13.137,13.137,0,0,0-17.759,5.467,12.552,12.552,0,0,0,4.831,6.309,13,13,0,0,0,24.554,5.749,11.029,11.029,0,0,0,15.612-3.383,11.614,11.614,0,0,0,20.621-4.2Z",
    transform: "translate(-132.824 -227.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M553.364,344.808a4.347,4.347,0,1,0,4.347,4.347,4.345,4.345,0,0,0-4.347-4.347",
    transform: "translate(-127.16 -226.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M548.066,337.439a3.312,3.312,0,1,0-3.314-3.312,3.315,3.315,0,0,0,3.314,3.312",
    transform: "translate(-127.54 -234.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M482.421,305.629a6.831,6.831,0,1,0,6.834,6.831,6.831,6.831,0,0,0-6.834-6.831",
    transform: "translate(-120.659 -248.492)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M485.608,303.905c-.144,0-.28.034-.423.04a8.244,8.244,0,0,0-7.374-11.4,12.313,12.313,0,0,0-22.788-9.13,11.805,11.805,0,1,0-.441,19.726,8.853,8.853,0,0,0,12.175,7.98,8.131,8.131,0,0,0,13.956,7.71,8.2,8.2,0,0,0,4.9,1.633,8.28,8.28,0,1,0,0-16.56",
    transform: "translate(-131.642 -264.571)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M484.186,303.905c-.144,0-.28.034-.422.04a8.244,8.244,0,0,0-7.374-11.4,12.313,12.313,0,0,0-22.788-9.13,11.8,11.8,0,0,0-13.285-.056,10.425,10.425,0,0,0-1.2,4.858,10.787,10.787,0,0,0,10.9,10.671,11.018,11.018,0,0,0,5.762-1.626,8.127,8.127,0,0,0,8.194,7.8,8.342,8.342,0,0,0,3.049-.587,7.186,7.186,0,0,0-.371,2.18,7.475,7.475,0,0,0,7.55,7.391,7.574,7.574,0,0,0,5.708-2.6,7.687,7.687,0,0,0,11.572-3.112A8.238,8.238,0,0,0,484.186,303.905Z",
    transform: "translate(-130.49 -264.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M474.651,268.849a3.727,3.727,0,1,0,3.728,3.727,3.727,3.727,0,0,0-3.728-3.727",
    transform: "translate(-119.512 -268.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M495.588,355.068a4.141,4.141,0,1,0,4.14,4.142,4.142,4.142,0,0,0-4.14-4.142",
    transform: "translate(-118.673 -221.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M645.895,416.637a10.13,10.13,0,0,0-4.92-8.684,8.634,8.634,0,0,0-8.737-14.308,11.791,11.791,0,0,0-22.653,6.483,11.073,11.073,0,0,0,1.013,22.1,10.85,10.85,0,0,0,1.782-.158,9.72,9.72,0,0,0,18.584,3.511,10.143,10.143,0,0,0,14.93-8.943",
    transform: "translate(-130.833 -204.239)",
    fill: "#cee3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M600.24,406.324a11.657,11.657,0,0,0,10.571,6.955,11.38,11.38,0,0,0,1.88-.169,10.417,10.417,0,0,0,10.242,10.1,10.262,10.262,0,0,0,9.366-6.278,10.37,10.37,0,0,0,5.05,1.31,10.517,10.517,0,0,0,7.921-3.641,10.156,10.156,0,0,0-4.693-6.65,8.634,8.634,0,0,0-8.737-14.308,11.791,11.791,0,0,0-22.653,6.483A11.076,11.076,0,0,0,600.24,406.324Z",
    transform: "translate(-130.436 -204.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M637.789,376.124a6.417,6.417,0,1,0,6.417,6.417,6.418,6.418,0,0,0-6.417-6.417",
    transform: "translate(-113.205 -209.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M629.81,418.1a4.968,4.968,0,1,0,4.968,4.968,4.967,4.967,0,0,0-4.968-4.968",
    transform: "translate(-116.819 -186.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M502.717,348.559a6.417,6.417,0,1,1,6.417,6.417,6.417,6.417,0,0,1-6.417-6.417",
    transform: "translate(-119.207 -228.283)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo);
export default __webpack_public_path__ + "static/media/carlogo.83f6127474cabc795a4cf1dac1bde84f.svg";
export { ForwardRef as ReactComponent };